import {MuWidget} from "mu-widget/lib/MuWidget";
import {UiTomSelect} from "./UiTomSelect";
import {TomOption} from "tom-select/dist/types/types";
import {UiDms} from "../dms/UiDms";
import {UiBuSubjectEditor} from "../dms/UiBuSubjectEditor";
import {BaseSelector} from "./BaseSelector";
import {DmsCL} from "../generated/DmsCL";

export class UiAccountSelector extends UiTomSelect
{
	public inSameCompany: string|boolean = false;

	beforeIndex() {
		super.beforeIndex();
		this.muAppendContent(`<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="orgDivisionCode"></em>
			</div>`
		);
	}

	afterIndex() {
		this.optionLoader = async (query, callback) => {
			// @ts-ignore
			const res: TomOption[] = await (UiDms.instance?.cl || new DmsCL()).findAccounts(query, this.inSameCompany);
			callback(res, []);
		}
		this.init();
	}


	/* createNew_click() {
		const bse = UiDms.instance.openInModal<UiBuSubjectEditor>("UiBuSubjectEditor", "Přidat subjekt");
		bse.savedPromise.then((ev) => {
			console.log(ev)
		});
	} */
}
export class UiAccountSelector_old extends MuWidget
{
	beforeIndex() {
		this.muAppendContent(`<div mu-widget="UiTomSelect" mu-id="input">
			<div mu-template="item" mu-widget=".">
				<strong mu-bind="name"></strong>
				<em mu-bind="orgDivisionCode"></em>
			</div>
			</div>`
		);
	}

	afterIndex() {
		const tom = (this.muNamedWidget.input as unknown as UiTomSelect);
		tom.optionLoader = async (query, callback) => {
			// @ts-ignore
			const res: TomOption[] = await UiDms.instance.cl.findAccounts(query);
			callback(res, []);
		}
		tom.init();
	}

	createNew_click() {
		// @ts-ignore
		const bse = UiDms.instance.openInModal<UiBuSubjectEditor>("UiBuSubjectEditor", "Přidat subjekt");
	}
}